ci_states
  .state("data_partners", {
    url: "/data_partners",
    templateUrl: "partials/data_partner/data_partner_list.html",
    controller: "DataPartnerListController",
    ncyBreadcrumb: {
      label: "Data Partners",
    },
  })
  .state("data_partners_view", {
    url: "/data_partners/:id?start_date&end_date",
    abstract: true,
    templateUrl: "partials/data_partner/data_partner_view.html",
    controller: "DataPartnerViewController",
    reloadOnSearch: true,
    ncyBreadcrumb: {
      parent: "data_partners",
      label: "{{ data_partner.name }}",
    },
  })
  .state("data_partners_view.overview", {
    url: "/overview",
    templateUrl: "partials/data_partner/data_partner_view_overview.html",
    controller: "DataPartnerAnalyticsController",
    ncyBreadcrumb: {
      label: "Overview",
    },
  })
  .state("data_partners_view.campaigns", {
    url: "/campaigns?list_start&list_end&q",
    controller: "CampaignListController",
    templateUrl: "partials/campaign/campaign_list.html",
    reloadOnSearch: true,
    ncyBreadcrumb: {
      label: "Campaigns",
    },
  })
  .state("data_partners_view.users", {
    url: "/users",
    controller: "UserListController",
    templateUrl: "partials/user/user_list.html",
    ncyBreadcrumb: {
      label: "Users",
    },
  });
